import { Box, Card, Typography } from "@material-ui/core";
import { Chart } from "chart.js";
import { useEffect, useRef } from "react";

export default function CardTopUsersAccessChart({ data }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const formatedData = {
    labels: data.map((item) => item.Usuario),
    datasets: [
      {
        axis: "y",
        label: "Quantidade de Acessos",
        data: data.map((item) => item.QuantidadeAcesso),
        backgroundColor: "#156082",
        borderColor: "#156082",
        borderRadius: 0,
        barPercentage: 0.5,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          return `Acessos: ${context.raw}`;
        },
      },
    },
    scales: {
      yAxes: {
        beginAtZero: true,
        grid: {
          color: "#e5e5e5",
        },
      },
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
  };

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");

    chartInstance.current = new Chart(ctx, {
      type: "bar",
      data: formatedData,
      options: options,
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, []);

  return (
    <Card style={{ minHeight: "350px", alignItems: "center" }}>
      <Typography variant="h3" component={Box} style={{ margin: "1rem" }}>
        Acessos - Top 10 usuários
      </Typography>
      <div style={{ height: "275px", width: "100%" }}>
        <canvas ref={chartRef}></canvas>
      </div>
    </Card>
  );
}
